@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources/"

@delegate:ResourceContentHash(1_235_139_903)
internal val Res.string.marketplace_sold_note: StringResource by lazy {
      StringResource("string:marketplace_sold_note", "marketplace_sold_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7933, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6561, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5937, 73),
      ))
    }

@delegate:ResourceContentHash(1_306_239_598)
internal val Res.string.marketplace_sort_high: StringResource by lazy {
      StringResource("string:marketplace_sort_high", "marketplace_sort_high", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8091, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6647, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6011, 53),
      ))
    }

@delegate:ResourceContentHash(-2_014_468_839)
internal val Res.string.marketplace_sort_low: StringResource by lazy {
      StringResource("string:marketplace_sort_low", "marketplace_sort_low", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8161, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6705, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6065, 52),
      ))
    }

@delegate:ResourceContentHash(101_137_762)
internal val Res.string.marketplace_sort_newest: StringResource by lazy {
      StringResource("string:marketplace_sort_newest", "marketplace_sort_newest", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8230, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6758, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6118, 39),
      ))
    }

@delegate:ResourceContentHash(-811_095_782)
internal val Res.string.marketplace_status_sold: StringResource by lazy {
      StringResource("string:marketplace_status_sold", "marketplace_status_sold", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8286, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6810, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6158, 39),
      ))
    }

@delegate:ResourceContentHash(1_021_778_090)
internal val Res.string.marketplace_subtitle: StringResource by lazy {
      StringResource("string:marketplace_subtitle", "marketplace_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8342, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6850, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6198, 92),
      ))
    }

@delegate:ResourceContentHash(812_158_875)
internal val Res.string.marketplace_time_days_ago: StringResource by lazy {
      StringResource("string:marketplace_time_days_ago", "marketplace_time_days_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8491, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6959, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6291, 49),
      ))
    }

@delegate:ResourceContentHash(2_094_969_652)
internal val Res.string.marketplace_time_hours_ago: StringResource by lazy {
      StringResource("string:marketplace_time_hours_ago", "marketplace_time_hours_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8549, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7013, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6341, 50),
      ))
    }

@delegate:ResourceContentHash(-2_012_089_126)
internal val Res.string.marketplace_time_just_now: StringResource by lazy {
      StringResource("string:marketplace_time_just_now", "marketplace_time_just_now", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8612, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7068, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6392, 45),
      ))
    }

@delegate:ResourceContentHash(-1_591_511_977)
internal val Res.string.marketplace_time_minutes_ago: StringResource by lazy {
      StringResource("string:marketplace_time_minutes_ago", "marketplace_time_minutes_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8670, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7122, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6438, 52),
      ))
    }

@delegate:ResourceContentHash(-1_205_191_231)
internal val Res.string.marketplace_time_weeks_ago: StringResource by lazy {
      StringResource("string:marketplace_time_weeks_ago", "marketplace_time_weeks_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8739, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7179, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6491, 50),
      ))
    }

@delegate:ResourceContentHash(-2_048_219_038)
internal val Res.string.marketplace_title: StringResource by lazy {
      StringResource("string:marketplace_title", "marketplace_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8802, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7238, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6542, 41),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("marketplace_sold_note", Res.string.marketplace_sold_note)
  map.put("marketplace_sort_high", Res.string.marketplace_sort_high)
  map.put("marketplace_sort_low", Res.string.marketplace_sort_low)
  map.put("marketplace_sort_newest", Res.string.marketplace_sort_newest)
  map.put("marketplace_status_sold", Res.string.marketplace_status_sold)
  map.put("marketplace_subtitle", Res.string.marketplace_subtitle)
  map.put("marketplace_time_days_ago", Res.string.marketplace_time_days_ago)
  map.put("marketplace_time_hours_ago", Res.string.marketplace_time_hours_ago)
  map.put("marketplace_time_just_now", Res.string.marketplace_time_just_now)
  map.put("marketplace_time_minutes_ago", Res.string.marketplace_time_minutes_ago)
  map.put("marketplace_time_weeks_ago", Res.string.marketplace_time_weeks_ago)
  map.put("marketplace_title", Res.string.marketplace_title)
}
